// @flow
import AgreementModal from './AgreementModal'

export default AgreementModal
